webpackJsonp([352],{

/***/ 1115:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntelligentCustomerServiceForm_vue__ = __webpack_require__(2723);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7273088_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntelligentCustomerServiceForm_vue__ = __webpack_require__(4206);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntelligentCustomerServiceForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7273088_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntelligentCustomerServiceForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 2723:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__intelligent_customer_service_rules__ = __webpack_require__(4205);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.onLoad();
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.onReload();
    next();
  },
  data: function data() {
    return {
      formRules: __WEBPACK_IMPORTED_MODULE_2__intelligent_customer_service_rules__["a" /* formRules */],
      tagOpts: [],
      loading: false,
      form: {
        whitelisttags: [],
        task_hint_text: '',
        taskid: null
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, request.map(['queryTaskTable', 'getUserTagTable', 'getUserTagDetail']), {
    normalizeTaskId: function normalizeTaskId(value) {
      // el-select 对 value 采用严格相等匹配，避免 "123" 与 123 匹配不上
      if (value === null || value === undefined || value === '') return value;
      var num = Number(value);
      return isNaN(num) ? value : num;
    },
    queryTaskTableWithLabel: function queryTaskTableWithLabel(params) {
      var _this = this;

      var keyword = params && (params.keyword || params.key || params.q);
      var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, params || {});
      if (keyword !== undefined && keyword !== null && keyword !== '') {
        var keywordStr = String(keyword).trim();
        if (/^\d+$/.test(keywordStr)) {
          body.taskids = [Number(keywordStr)];
        } else {
          body.text = keywordStr;
        }
      }
      // 编辑时，会传入taskid，这里需要转成taskids以支持任务ID查询
      if (body.taskid) {
        body.taskids = [Number(body.taskid)];
        delete body.taskid;
      }
      body.current_page = body.current_page || 1;
      body.per_page = body.per_page || 50;
      return this.queryTaskTable(body).then(function (res) {
        var items = _.get(res, 'data.data', []);
        if (!_.isArray(items) && items) items = [items];
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          if (!item) continue;
          var title = item.title || '';
          if (item.taskid !== undefined) item.taskid = _this.normalizeTaskId(item.taskid);
          var id = item.taskid !== undefined ? item.taskid : item.id || '';
          item.label = title + '/' + id;
        }
        return res;
      });
    },
    onLoad: function onLoad() {
      this.setForm();
    },
    onReload: function onReload() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.onLoad();
    },
    setForm: function setForm() {
      var _this2 = this;

      request.page('getIntelligentCustomerServiceConfig').then(function (_ref) {
        var data = _ref.data;

        filter.setLoop(_this2.form, data);
        _this2.form.taskid = _this2.normalizeTaskId(_this2.form.taskid);
        _this2.tagOpts = data.whitelisttags_arr || [];
      });
    },
    getForm: function getForm() {
      return filter.copyJson(this.form);
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this3.update();
        } else {
          _this3.$message.error('提交内容填写不正确！');
        }
      });
    },
    update: function update() {
      var _this4 = this;

      request.common('setIntelligentCustomerServiceConfig', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getForm())).then(function () {
        _this4.$confirm(_this4.$route.meta.title + '成功', '提示', { type: 'success' }).then(function () {});
      });
    },
    remoteMethodTag: function remoteMethodTag(query) {
      var _this5 = this;

      if (query !== '') {
        this.loading = true;
        setTimeout(function () {
          request.alert('getUserTagName', { query: query }).then(function (_ref2) {
            var data = _ref2.data;

            _this5.tagOpts = data;
            _this5.loading = false;
          });
        }, 500);
      }
    }
  })
});

/***/ }),

/***/ 4205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var formRules = {
  whitelisttags: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择白名单标签', 'array'))],
  task_hint_text: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入新手任务跳转文案', 'string'))],
  taskid: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择新手跳转任务', 'integer'))]
};

/***/ }),

/***/ 4206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("智能客服管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("表单")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.formRules,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"prop":"whitelisttags","label":"白名单标签"}},[_c('el-select',{attrs:{"multiple":"","filterable":"","remote":"","reserve-keyword":"","placeholder":"请输入关键词","remote-method":_vm.remoteMethodTag,"loading":_vm.loading},model:{value:(_vm.form.whitelisttags),callback:function ($$v) {_vm.$set(_vm.form, "whitelisttags", $$v)},expression:"form.whitelisttags"}},_vm._l((_vm.tagOpts),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.tagname,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"task_hint_text","label":"新手任务跳转文案"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.form.task_hint_text),callback:function ($$v) {_vm.$set(_vm.form, "task_hint_text", $$v)},expression:"form.task_hint_text"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"taskid","label":"新手跳转任务"}},[_c('sj-remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"taskid","keyword-key":"keyword","label-key":"label","value-key":"taskid","placeholder":"输入关键字搜索","remote-method":_vm.queryTaskTableWithLabel},model:{value:(_vm.form.taskid),callback:function ($$v) {_vm.$set(_vm.form, "taskid", $$v)},expression:"form.taskid"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","native-type":"submit"}},[_vm._v("提交表单\n            ")])],1)],1)])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/intelligent-customer-service.200e4871fef768961d65.js